import { useContext } from "react";
import { ModalContext } from "../../Components/Modals";
import ModalConfirmAction, {
  ModalConfirmActionElementProps,
} from "../../Components/Modals/ModalConfirmAction/modal-confirm-action";
import { assetService } from "../../Core/Api/services";
import useCustomSnackbar from "./useCustomSnackbar";
import { useTranslation } from "react-i18next";

const useTrashActions = () => {
  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const enqueueCustomSnackbar = useCustomSnackbar();
  const { t } = useTranslation();

  const TrashObjectByIds = (objectIds: number[], callback?: (objectId: number) => void) => {
    if (!openModal) return;

    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      displayComment: true,
      commentLabel: t("modal:comment.letUsKnowYourTrashReason"),
      title: t("modal:title.putToTrash"),
      canConfirmWithoutComment: true,
      onConfirm: () => {
        objectIds.forEach((id) => {
          assetService.PutToTrash(id).then((response) => {
            if (response.success) enqueueCustomSnackbar(t("alert:success.itemPutToTrash", { id }), "success");
            else enqueueCustomSnackbar(t("alert:error.trashingItem", { id, message: response.message }), "error");

            callback && response.success && callback(id);
          });
        });
      },
    });
  };

  const UntrashObjectByIds = (objectIds: number[], callback?: (objectId: number) => void): boolean => {
    objectIds.forEach((id) => {
      assetService.UnTrash(id).then((response) => {
        if (response.success) {
          enqueueCustomSnackbar(t("alert:success.itemUntrashed", { id }), "success");
          callback && response.success && callback(id);
        } else {
          enqueueCustomSnackbar(t("alert:error.recyclingItem", { id, message: response.message }), "error");
          return false;
        }
      });
    });

    return true;
  };

  const DeleteForeverObjectByIds = (objectIds: number[]): boolean => {
    if (!openModal) return false;

    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      displayComment: true,
      commentLabel: t("modal:comment.letUsKnowYourDeleteReason"),
      title: t("modal:title.confirmDeletePermanently"),
      onConfirm: () => {
        objectIds.forEach((id) => {
          assetService.ClearTrash(objectIds).then((response) => {
            if (response) enqueueCustomSnackbar(t("alert:success.itemDeleted", { id }), "success");
            else {
              enqueueCustomSnackbar(t("alert:error.deletingItems"), "error");
              return false;
            }
          });
        });

        return true;
      },
    });

    return false;
  };

  return {
    TrashObjectByIds,
    UntrashObjectByIds,
    DeleteForeverObjectByIds,
  };
};

export default useTrashActions;
